import { createIcon } from '@chakra-ui/react';

export const MbeEnFlag = createIcon({
  displayName: 'MbeEnFlag',
  viewBox: '0 0 64 64',
  path: (
    <g fill="none" fillRule="evenodd">
      <g transform="translate(4 4)">
        <mask fill="#fff" id="ycfuydtrwb">
          <use xlinkHref="#wrmutgyxaa" />
        </mask>
        <path
          d="M28 1.412C13.34 1.412 1.412 13.339 1.412 28c0 14.66 11.927 26.588 26.588 26.588 14.66 0 26.588-11.927 26.588-26.588C54.588 13.34 42.661 1.412 28 1.412M28 56C12.56 56 0 43.44 0 28 0 12.56 12.56 0 28 0s28 12.56 28 28c0 15.439-12.56 28-28 28"
          fill="#E2001A"
          mask="url(#ycfuydtrwb)"
        />
      </g>
      <path
        d="M32 19.479c6.915 0 12.522 5.606 12.522 12.521 0 6.915-5.607 12.521-12.522 12.521s-12.522-5.606-12.522-12.52c0-6.916 5.607-12.522 12.522-12.522"
        fill="#E6E6E6"
      />
      <path
        d="M22.067 24.377a12.474 12.474 0 0 0-2.157 4.357h6.514l-4.357-4.357zM44.09 28.734a12.482 12.482 0 0 0-2.157-4.358l-4.357 4.358h6.514zM19.91 35.266a12.476 12.476 0 0 0 2.157 4.357l4.357-4.357H19.91zM39.623 22.067a12.483 12.483 0 0 0-4.357-2.157v6.514l4.357-4.357zM24.377 41.933a12.483 12.483 0 0 0 4.357 2.157v-6.514l-4.357 4.357zM28.734 19.91a12.476 12.476 0 0 0-4.357 2.157l4.357 4.357V19.91zM35.266 44.09a12.476 12.476 0 0 0 4.357-2.157l-4.357-4.357v6.514zM37.576 35.266l4.357 4.358a12.47 12.47 0 0 0 2.157-4.358h-6.514z"
        fill="#00489A"
      />
      <path
        d="M44.415 30.367H33.633V19.585a12.641 12.641 0 0 0-3.266 0v10.782H19.585a12.636 12.636 0 0 0 0 3.266h10.782v10.782a12.642 12.642 0 0 0 3.266 0V33.633h10.782a12.641 12.641 0 0 0 0-3.266"
        fill="#E2001A"
      />
      <path
        d="m35.266 35.266 5.588 5.588c.257-.257.502-.526.736-.804l-4.784-4.784h-1.54zM28.734 35.266l-5.588 5.588c.257.257.526.502.804.736l4.784-4.784v-1.54zM28.734 28.734l-5.588-5.588c-.257.257-.502.525-.736.804l4.784 4.784h1.54zM35.266 28.734l5.588-5.588a12.592 12.592 0 0 0-.804-.736l-4.784 4.784v1.54z"
        fill="#E2001A"
      />
    </g>
  ),
});
